export const CALENDAR = '/calendar'
